// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2930":"9a647b6f","3211":"1e3ed956","5744":"9a647b6f","7938":"1e3ed956","9246":"1e3ed956"}[chunkId] + ".chunk.css";
};